import { useEffect } from 'react';
import { UseFormReturn, useWatch } from 'react-hook-form';
import { QuestionnaireFormData } from '@/features/questionnaires/types/questionnaire.interface';
import { Question } from '@aphp-ema/common/questionnaire';

export const useQuestionOrderSync = (
  form: UseFormReturn<QuestionnaireFormData>,
) => {
  const questions = useWatch({ control: form.control, name: 'questions' });

  useEffect(() => {
    if (questions && questions.length > 0) {
      // Update order values to match array indices
      questions.forEach((question: Question, index: number) => {
        if (question.order !== index) {
          form.setValue(`questions.${index}.order`, index, {
            shouldValidate: false,
            shouldDirty: true,
          });
        }
      });
    }
  }, [questions, form]);
};
